'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dScheduled$002dMeal from "./mealorama.-Scheduled-Meal.js";
var $p;
/** @constructor */
function $c_Lmealorama_ScheduledMeal$() {
}
export { $c_Lmealorama_ScheduledMeal$ as $c_Lmealorama_ScheduledMeal$ };
$p = $c_Lmealorama_ScheduledMeal$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ScheduledMeal$;
/** @constructor */
function $h_Lmealorama_ScheduledMeal$() {
}
export { $h_Lmealorama_ScheduledMeal$ as $h_Lmealorama_ScheduledMeal$ };
$h_Lmealorama_ScheduledMeal$.prototype = $p;
$p.aSt = (function(x$0) {
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(1));
  return new $j_mealorama$002e$002dScheduled$002dMeal.$c_Lmealorama_ScheduledMeal($x_2.l, $x_2.h, $x_1.l, $x_1.h, x$0.g(2), x$0.g(3), x$0.g(4), x$0.g(5), (!(!x$0.g(6))));
});
var $d_Lmealorama_ScheduledMeal$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ScheduledMeal$, "mealorama.ScheduledMeal$", ({
  GR: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_ScheduledMeal$ as $d_Lmealorama_ScheduledMeal$ };
var $n_Lmealorama_ScheduledMeal$;
function $m_Lmealorama_ScheduledMeal$() {
  if ((!$n_Lmealorama_ScheduledMeal$)) {
    $n_Lmealorama_ScheduledMeal$ = new $c_Lmealorama_ScheduledMeal$();
  }
  return $n_Lmealorama_ScheduledMeal$;
}
export { $m_Lmealorama_ScheduledMeal$ as $m_Lmealorama_ScheduledMeal$ };
//# sourceMappingURL=mealorama.-Scheduled-Meal$.js.map
